import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const JOB_TITLE_MAX_LENGTH = 255;

export const USER_PROFILE_FORM_VALIDATION_SCHEMA = yupResolver(
  yup.object({
    firstName: yup
      .string()
      .trim()
      .required('This field is required. Please enter First Name'),
    lastName: yup
      .string()
      .trim()
      .required('This field is required. Please enter Last Name'),
    jobTitle: yup
      .string()
      .trim()
      .max(
        JOB_TITLE_MAX_LENGTH,
        `Job Title must be ${JOB_TITLE_MAX_LENGTH} characters or fewer`
      ),
    email: yup
      .string()
      .email('Please enter a valid email address with the "@" symbol')
      .required(
        'Please make sure your email address belongs to client authorized domains'
      ),
    confirmEmail: yup
      .string()
      .oneOf(
        [yup.ref('email'), null] as unknown as string[],
        'Please ensure the emails match'
      )
      .when('email', ([email]) =>
        email === ''
          ? yup
              .string()
              .email('Please enter a valid email address with the "@" symbol')
              .required('Please ensure the emails match')
          : (yup.string() as unknown as yup.AnySchema)
      ),
    role: yup.string().required('Please select Role from the list'),
    client: yup
      .object()
      .nullable()
      .when('role', ([role], schema) => {
        const roleObject =
          role === 'user'
            ? schema
                .shape({
                  value: yup.number(),
                })
                .required('Please select Client from the list')
            : (schema as yup.AnySchema);

        return roleObject;
      }),
  })
);

export const USERS_PROFILE_STATUSES = {
  ACTIVE: 'Active',
  LOCKED: 'Locked',
} as const;

export type UserProfileStatus =
  (typeof USERS_PROFILE_STATUSES)[keyof typeof USERS_PROFILE_STATUSES];

export const USER_NOT_SAVED_TITLE = 'User not saved';
export const USER_NOT_SAVED_FALLBACK_MESSAGE =
  'Something went wrong. Please try again.';
